export const API_NAME = "admin";
export const ROUTE_NAME = "admin";
export const COMPONENT_NAMES = ["admin", "admins"];
